import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import {styled} from '@mui/system';

import {concatUrl} from '../helpers/url';
import history from '../helpers/history';
import {postCall} from '../helpers/request';
import GlobalContext from '../helpers/context';
import {checkUserRoles} from '../helpers/authentication';
import {ROOT_PATH} from '../settings';
import statusOptions from './CurationProfileStatusOptions';
import CurationProfileStatusLabel from './CurationProfileStatusLabel';


const StyledFormControl = styled(FormControl)({
    minWidth: 200,
    textAlign:'left'
});


class CurationProfileStatusDropDown extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            status: ''
        };

        this.accepted_roles = ['admin', 'manager', 'reviewer'];
        this.save_curation_profile_metadata_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'metadata', 'save');
    }

    componentDidMount(){
        this.context.checkUserAccess(this.conditionCallback);
        if (this.state.status === '' && this.props.metadata.status && this.props.metadata.status.length > -1){
            this.setState({status: this.props.metadata.status[0].status});
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.metadata !== prevProps.metadata || this.state.status === ''){
            if (this.props.metadata.status){
                if (this.props.metadata.status.length > -1){
                   this.setState({status: this.props.metadata.status[0].status});
                }
            }
        }
    }

    conditionCallback = (user) => {
        return checkUserRoles(user, this.accepted_roles);
    };


    // +++ save curation profile status +++++++++++++++++++++++++++++++++++++++++++++++

    saveCurationProfileStatusFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not save the curation profile status.');
    };

    saveCurationProfileStatusDone = (data) => {
        if (data && data.no_access) {
            history.push(ROOT_PATH);
        }else{
            this.context.displayGlobalInfo('The changes were successfully saved');
        }
    };

    saveCurationProfileStatus = (event) => {
        this.setState({status: event.target.value});
        this.form_data = {
            curation_profile_id: this.props.curation_profile_id,
            workspace_id: this.props.workspace_id,
            status: event.target.value
        };
        postCall(this.save_curation_profile_metadata_url , this.form_data,
            this.saveCurationProfileStatusDone,
            this.saveCurationProfileStatusFailed);
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <StyledFormControl>
                    <InputLabel id="status-label">
                        Status
                    </InputLabel>
                    <Select
                        labelId="status-label"
                        label="Status"
                        id="status"
                        variant="outlined"
                        data-bt="status_drop_down"
                        value={this.state.status}
                        onChange={this.saveCurationProfileStatus}
                    >
                        {statusOptions.map((status_option) =>
                            <MenuItem value={status_option.key} key={status_option.key} selected={status_option.label === this.state.status}>
                                <CurationProfileStatusLabel status={status_option.key} />
                            </MenuItem>)}
                    </Select>
                </StyledFormControl>
            )}
            </GlobalContext.Consumer>
        );
    }
}

CurationProfileStatusDropDown.contextType = GlobalContext;

CurationProfileStatusDropDown.propTypes = {
    curation_profile_id: PropTypes.number.isRequired,
    workspace_id: PropTypes.number.isRequired,
    metadata: PropTypes.object
};

export default CurationProfileStatusDropDown;
